//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            loading: false,
            dialogVisible: false,
            privacyChecked: false,
            rules: {},
            form: {
                name: '',
                mail: '',
                subject: '',
                body: '',
            }
        };
    },

    methods: {
        send () {
            this.loading = true;

            axios.post('contact-mail', this.form).then(response => {
                this.$message({
                    type: 'success',
                    message: response.data.message
                });
                this.loading = false;
                this.$refs.form.clearValidate();
                this.$refs.form.resetFields();
            }).catch(error => {
                if (error.response.status === 422) {
                    this.$helper.FormValidator.validate(this.$refs.form, this.form, this.rules, error.response.data.errors);
                }

                this.loading = false;
            });
        }
    }
};
